import module from 'module';
import { ajax } from 'OK/utils/vanilla';
import logger from 'OK/logger';

var
    /** @type {{}} */
    store = {},
    /** @type {string[]} */
    toFetch = [],
    /** @type {{}} */
    events = {},
    /** @type {?number} */
    interval,
    /** @type {string} */
    HASH = '$Hash$',
    /** @type {string} */
    MODULE_PREFIX = 'OK/pms!',
    /** @type {number} */
    TIMEOUT = module.config().timeout || 60000 /* 1 минута */
    ;

/** Получаем alias с префиксом нашего модуля */
function getPrefixedAlias(alias) {
    return MODULE_PREFIX + alias;
}

/* Нотифицируем заинтересованных об обновлениях */
function notify(eventName) {
    var
        /** @type {function()[]} */
        subscribers = events[eventName] || [],
        /** @type {number} */
        len = subscribers.length;
    while (len--) {
        subscribers[len]();
    }
}

/**
 * @param {string} alias
 * @returns {boolean}
 */
function shouldUpdate(alias) {
    return !store.hasOwnProperty(alias);
}

/**
 * @see one.app.community.dk.blocks.user.conf.PmsConversion
 * @typedef {Object} CfgWithHash
 * @property {string} data
 * @property {string} $Hash$
 */

/**
 * @param {string} alias
 * @returns {*}
 */
function getCfg(alias) {
    var /** @type {CfgWithHash} */ item = store[alias];
    return item && item.data || {};
}

/**
 * @param {string} alias
 * @param {CfgWithHash} config
 */
function registerCfg(alias, config) {
    var /** @type {{}} */ item = {
        data: {},
    };
    if (config && config.data) {
        item.data = JSON.parse(config.data);
    } else {
        console.warn('Error while loading PMS config: ', alias);
        logger.error('pms', 'Config was not loaded', alias);
    }
    item[HASH] = config[HASH];
    store[alias] = item;
    notify(alias);
    return getCfg(alias);
}

/**
 * @see one.app.community.dk.blocks.user.conf.PmsEndpoint
 * @typedef {Object} CfgInfo
 * @property {string} alias
 * @property {string} hash
 */

/**
 * Данные запроса обновления конфигурации в виде сериализованного JSON
 * @returns {string}
 */
function makeData() {
    var
        /** @type {CfgInfo[]} */
        info = [],
        /** @type {string} */
        alias,
        /** @type {number} */
        idx = 0,
        /** @type {number} */
        len = toFetch.length,
        /** @type {CfgWithHash} */
        item;
    for (; idx < len; idx += 1) {
        alias = toFetch[idx];
        item = store[alias];
        info.push({
            'alias': alias,
            'hash': item[HASH] || '0'
        });
    }
    return JSON.stringify(info);
}

/* Опрашиваем сервер */
function refresh() {
    ajax({
        url: '/web-api/upms',
        headers: {
             'Content-Type': 'application/json'
        },
        data: makeData(),
        dataType: 'json'
    }).then(function (result) {
        var
            /** @type {[]} */
            response = result.response,
            /** @type {string[]} */
            aliases = Object.keys(response),
            /** @type {string} */
            alias,
            /** @type {number} */
            idx = 0,
            /** @type {number} */
            len = aliases.length;
        for (; idx < len; idx += 1) {
            alias = aliases[idx];
            var moduleId = getPrefixedAlias(alias);
            aliases[idx] = moduleId;

            /* Удаляем изменённый конфиг из общей мапы requirejs */
            requirejs.undef(moduleId);
            /* Регистрируем новые значения в глобальном store */
            registerCfg(alias, response[alias]);
        }

        if (len) {
            /* Добавляем данные в кэш requirejs */
            require(aliases);
        }
    });
}

/**
 * @param {string} alias
 */
function remember(alias) {
    if (!alias) {
        /* Ничего не делаем */
        return;
    }
    if (toFetch.indexOf(alias) === -1) {
        /* Добавим имя конфигурации к списку периодического опроса обновлений */
        toFetch.push(alias);
    }
    if (!interval && (TIMEOUT > 0)) {
        /* Запустим периодический опрос */
        interval = window.setInterval(refresh, TIMEOUT);
    }
}

// Определяем глобальный стор конфигурации
if (typeof window !== 'undefined') {
    window.cfgStore = {
        /**
         * @param {string} alias
         * @returns {{}}
         */
        getCfg: function (alias) {
            remember(alias);
            return getCfg(alias);
        },
        /**
         * @param {string} alias
         * @param {function()} callback
         */
        subscribe: function(alias, callback) {
            if (!events[alias]) {
                events[alias] = [];
            }
            events[alias].push(callback);
        }
    };

    if (window.inline_resources !== undefined && window.inline_resources.pms !== undefined) {
    	for (var alias in window.inline_resources.pms){
    		registerCfg(alias, window.inline_resources.pms[alias])
    		remember(alias);
    	}
    	window.inline_resources.pms = {}
    }
}

function fetch(alias) {
    return ajax({
        type: 'GET',
        url: '/web-api/pms?name=' + encodeURIComponent(alias),
        headers: {
            'Content-Type': 'application/json'
        },
        dataType: 'json'
    }).then(function (result) {
        return Promise.resolve(result.response);
    });
}

function load(alias, req, onload, config) {
    if (config.isBuild) {
        onload();
        return;
    }

    if (!shouldUpdate(alias)) {
        onload(getCfg(alias));
    } else {
        fetch(alias).then(function (config) {
            onload(registerCfg(alias, config));
            remember(alias);
        });
    }
}

export default { load };

export { load };
